import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import { BaseNotifier } from './baseNotifier';
import Notification from '../elementals/notification';
import { Toaster, toast } from 'sonner';
const MAX_VISIBLE_TOASTS = 5;
const defaultIconName = {
    info: 'info-circle',
    caution: 'exclamation-triangle',
    error: 'exclamation-circle',
    success: 'check-circle',
};
export class ToastNotifier extends BaseNotifier {
    constructor() {
        super();
        this._containerDomNode = null;
    }
    initialize() {
        this._containerDomNode = document.createElement('div');
        document.body.appendChild(this._containerDomNode);
        render(_jsx(Toaster, { visibleToasts: MAX_VISIBLE_TOASTS, toastOptions: { unstyled: true } }), this._containerDomNode);
    }
    open(initialOptions) {
        const options = super.prepareOptions(initialOptions);
        const { role, message, title, autoDismiss, dismissible, duration, showIcon, iconName, } = options;
        const toastId = toast(_jsx(Notification, { isVisible: true, iconName: iconName || (showIcon ? defaultIconName[role] : null), iconStyle: 'light', color: role, message: message, title: title, fluid: true, onCloseButton: dismissible, onClose: dismissible
                ? () => {
                    toast.dismiss(toastId);
                }
                : undefined }), {
            description: message,
            duration: autoDismiss ? duration : Infinity,
        });
        return toastId;
    }
    close() {
    }
    closeAll() {
        toast.dismiss();
    }
    destroy() {
        if (this._containerDomNode) {
            unmountComponentAtNode(this._containerDomNode);
            document.body.removeChild(this._containerDomNode);
        }
        super.destroy();
    }
}
//# sourceMappingURL=toastNotifier.js.map